import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import { FreeMode } from 'swiper'
import Link from 'next/link'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { useEffect, useState } from 'react'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import { generateUri } from '@commerce/utils/uri-util'
import { useUI } from '@components/ui/context'
import { getCurrentPage } from '@framework/utils/app-util'
import {
  DESKTOP_BANNER_IMAGE_HEIGHT,
  EmptyGuid,
  MOBILE_BANNER_IMAGE_HEIGHT,
} from '@components/utils/constants'
import { useMoEngageEvent } from 'hooks/useMoengageEvent'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'
import { GA_EVENT } from 'hooks/ga_event.modal'
import CustomSwiperPLPTopBanner from './CustomSwiperPLPTopBanner'

declare const window: any

const CUSTOM_SWIPER_ENABLE = false

export default function CollectionSlider({
  props,
  sliderCount,
  mobileSliderCount,
}: any) {
  const { user } = useUI()
  let currentPage = getCurrentPage()
  const trackMoEngageEvent = useMoEngageEvent()
  const { isOnlyMobile } = props?.deviceInfo
  const [viewedBanners, setViewedBanners] = useState(new Set())

  useEffect(() => {
    setViewedBanners(new Set())
  }, [props.id])

  useEffect(() => {
    const bannerCount = Math.round(props?.deviceInfo?.isDesktop === true ? sliderCount : mobileSliderCount)
    if (props?.topBanners?.length >= 0) {
      for (let i = 0; i < bannerCount; i++) {
        triggerPlpBannerImpressiom(i)
      }
    }
  }, [props?.topBanners])

  function bannerClick(img: any, idx: any) {
    let component_type = 'image'
    if (img.gif) component_type = 'gif'
    else if (img.video) component_type = 'video'
    if (currentPage) {
      trackMoEngageEvent(
        MO_ENGAGE_EVENT.BANNER_CLICK,
        {
          previous_page_url: currentPage,
          position: idx,
          banner_name: img?.title ?? img?.name,
          component_type,
          component_name: 'Collection Banner',
          URL: img?.url,
        },
        window
      )

      recordGA4Event(window, GA_EVENT.BANNER_CLICK, {
        current_page: currentPage,
        position: idx,
        banner_name: img?.title ?? img?.name,
        component_type,
        component_name: 'Collection Banner',
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })

      recordGA4Event(window, GA_EVENT.PLP_BANNER_CLICK, {
        current_page: currentPage,
        plp_name: props?.name,
        position: props?.images?.length == 1 ? 0 : idx + 1,
        banner_name: img?.title ?? img?.name,
        component_name: 'PLP Banner',
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
        device: props?.deviceInfo?.isDesktop === true ? 'Desktop' : 'Mobile' 
      })
    }
  }
  const [imageHeight, setImageHeight] = useState(0)
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const [isImageLoadedDesktop, setIsImageLoadedDesktop] = useState(false)

  const getPadding = () => {
    if (isOnlyMobile) {
      if (props?.topBanners?.length > 1) {
        return 'px-0'
      } else {
        return 'px-0'
      }
    } else {
      return 'px-4'
    }
  }

  function triggerPlpBannerImpressiom(idx:any) {
   const index = Math.round(idx)
    if (!viewedBanners.has(index)) {
      const img = props?.topBanners[index]
      recordGA4Event(window, GA_EVENT.PLP_BANNER_IMPRESSIONS, {
        current_page: currentPage,
        plp_name: props?.name,
        position: props?.images?.length == 1 ? 0 : index + 1,
        banner_name: img?.title ?? img?.name,
        component_name: 'PLP Banner',
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
        device: props?.deviceInfo?.isDesktop === true ? 'Desktop' : 'Mobile'
      })      
      setViewedBanners(prevSet => new Set(prevSet).add(index))
    }
  }

  return (
    <>
      {/* MOBILE BANNER */}
      <div className="mobile-tab">
        {/* <div
          className="container animate-pulse"
          style={{ display: isImageLoaded ? 'none' : 'block' }}
        >
          <div
            className={`rounded bg-slate-200`}
            style={{
              height: `${MOBILE_BANNER_IMAGE_HEIGHT}px`,
              width: '100%',
            }}
            id="plp-banner-skeleton"
          />
        </div> */}
        <div
          className={`container flex items-center justify-center w-full ${getPadding()} mx-auto mt-4 lg:px-6 sm:px-0 sm:mt-4 md:mt-0 sm:hidden tablet-flex-visible`}
          style={{ display: !isImageLoaded ? 'none' : 'block' }}
        >
          {props?.topBanners?.length > 1 ? (
            <>
              {CUSTOM_SWIPER_ENABLE ? (
                <CustomSwiperPLPTopBanner
                  className="icon-bg-none category-banner-swiper"
                  images={props.images}
                  isOnlyMobile={!!isOnlyMobile}
                  swiperProps={{
                    slidesPerView: 1.4,
                    slidesPerView1: 1.5,
                    slidesPerView2: 2.5,
                    slidesPerView3: 4,
                    spaceBetween: 10,
                  }}
                  setIsImageLoaded={(payload: boolean) => {
                    setIsImageLoaded(payload)
                  }}
                />
              ) : (
                <Swiper
                  slidesPerView={mobileSliderCount}
                  spaceBetween={6}
                  navigation={true}
                  loop={false}
                  freeMode={true}
                  modules={[FreeMode]}
                  breakpoints={{
                    640: {
                      slidesPerView: mobileSliderCount,
                    },
                    768: {
                      slidesPerView: mobileSliderCount,
                    },
                    1024: {
                      slidesPerView: sliderCount,
                    },
                  }}
                  className="mySwiper icon-bg-none category-banner-swiper"
                  onSlideChange={({ activeIndex }) => {
                    triggerPlpBannerImpressiom((activeIndex + mobileSliderCount) - 1)
                  }}
                >
                  {props?.images?.map((img: any, idx: number) => {
                    return (
                      <SwiperSlide key={idx}>
                        <div
                          className={'relative w-full px-0'}
                          style={{
                            maxHeight: `${MOBILE_BANNER_IMAGE_HEIGHT}px`,
                          }}
                        >
                          <Link legacyBehavior href={img?.link || '#'} passHref>
                            <a
                              onClick={() => bannerClick(img, idx)}
                              className="block"
                            >
                              <img
                                onLoad={() => {
                                  setIsImageLoaded(true)
                                }}
                                src={
                                  generateUri(
                                    img?.mobileUrl || img?.url,
                                    'h=795&q=50'
                                  ) || IMG_PLACEHOLDER
                                }
                                alt="Collection Banner"
                                fetchPriority={idx === 0 ? 'high' : 'low'}
                              />
                            </a>
                          </Link>
                          <div className="absolute z-10 text-left bottom-3 left-4">
                            <h3 className="font-medium text-white text-14">
                              {img?.title}
                            </h3>
                            <p className="mb-2 font-normal text-left text-white text-10">
                              {img?.description}
                            </p>
                            {img?.title ? (
                              <>
                                <Link legacyBehavior href={img?.link} passHref>
                                  <a
                                    onClick={() => bannerClick(img, idx)}
                                    className="font-medium text-left text-white underline text-12"
                                  >
                                    Shop now
                                  </a>
                                </Link>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              )}
            </>
          ) : (
            <>
              {props?.topBanners?.map((img: any, idx: number) => {
                return (
                  <div className={`w-full max-h-[530px] px-0`} key={idx}>
                    <Link legacyBehavior href={img?.link || '#'} passHref>
                      <a
                        onClick={() => bannerClick(img, idx)}
                        className="block image-container"
                      >
                        <img
                          className="image h-[530px]"
                          onLoad={({ target }) => {
                            const { naturalWidth, naturalHeight } =
                              target as HTMLImageElement
                            setImageHeight(naturalHeight)
                            setIsImageLoaded(true)
                          }}
                          src={
                            generateUri(
                              img?.mobileUrl || img?.url,
                              'h=795&q=50'
                            ) || IMG_PLACEHOLDER
                          }
                          alt="Collection Banner"
                          fetchPriority={idx === 0 ? 'high' : 'low'}
                        />
                      </a>
                    </Link>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </div>

      {/* DESKTOP BANNER */}
      <div className="desktop-laptop">
        {/* <div
          className="container mx-auto mt-0 animate-pulse sm:flex lg:px-6 sm:px-0 sm:mt-4"
          style={{ display: !isImageLoadedDesktop ? 'none' : 'block' }}
        >
          <div
            className={'w-full rounded bg-slate-200'}
            style={{
              height: `${DESKTOP_BANNER_IMAGE_HEIGHT}px`,
            }}
          />
        </div> */}
        <div
          className="container items-center justify-center hidden w-full mx-auto mt-0 sm:flex lg:px-6 sm:px-0 sm:mt-4"
          style={{
            // display: !isImageLoadedDesktop ? 'none' : 'block',
            maxHeight: `${DESKTOP_BANNER_IMAGE_HEIGHT}px`,
          }}
        >
          {props?.topBanners?.length > 1 ? (
            <>
              <Swiper
                slidesPerView={mobileSliderCount}
                spaceBetween={6}
                navigation={true}
                loop={false}
                freeMode={true}
                modules={[FreeMode]}
                breakpoints={{
                  640: {
                    slidesPerView: mobileSliderCount,
                  },
                  768: {
                    slidesPerView: mobileSliderCount,
                  },
                  1024: {
                    slidesPerView: sliderCount,
                  },
                }}
                className="mySwiper icon-bg-none category-banner-swiper"
                onSlideChange={({ activeIndex }) => {
                  triggerPlpBannerImpressiom((activeIndex + sliderCount) - 1)
                }}
              >
                {props?.topBanners?.map((img: any, idx: number) => {
                  return (
                    <SwiperSlide key={idx}>
                      <div
                        className={'relative w-full px-0'}
                        data-id={`desktop-multiple-banner-${idx}`}
                        style={{
                          maxHeight: `${DESKTOP_BANNER_IMAGE_HEIGHT}px`,
                        }}
                      >
                        <Link legacyBehavior href={img?.link || '#'} passHref>
                          <a
                            onClick={() => bannerClick(img, idx)}
                            className="block"
                          >
                            <img
                              src={
                                generateUri(img?.url, 'h=795&q=50') ||
                                IMG_PLACEHOLDER
                              }
                              onLoad={({ target }) => {
                                setIsImageLoadedDesktop(true)
                                const { naturalWidth, naturalHeight } =
                                  target as HTMLImageElement
                                setImageHeight(naturalHeight)
                              }}
                              alt="Collection Banner"
                              fetchPriority={idx === 0 ? 'high' : 'low'}
                              style={{
                                height: `100% !important`,
                              }}
                            />
                          </a>
                        </Link>
                        <div className="absolute z-10 text-left bottom-3 left-4">
                          <h3 className="font-medium text-white text-14">
                            {img?.title}
                          </h3>
                          <p className="mb-2 font-normal text-left text-white text-10">
                            {img?.description}
                          </p>
                          {img?.title ? (
                            <>
                              <Link legacyBehavior href={img?.link} passHref>
                                <a
                                  onClick={() => bannerClick(img, idx)}
                                  className="font-medium text-left text-white underline text-12"
                                >
                                  Shop now
                                </a>
                              </Link>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </>
          ) : (
            <>
              {props?.topBanners?.map((img: any, idx: number) => {
                return (
                  <div
                    className={`w-full  px-0`}
                    key={idx}
                    data-id="desktop-single-banner"
                    style={{
                      maxHeight: `${DESKTOP_BANNER_IMAGE_HEIGHT}px !important`,
                    }}
                  >
                    <Link legacyBehavior href={img?.link || '#'} passHref>
                      {img?.url.includes('.gif') ? (
                        <a
                          onClick={() => bannerClick(img, idx)}
                          className="block image-container"
                        >
                          <img
                            className={'image'}
                            onLoad={({ target }) => {
                              setIsImageLoadedDesktop(true)

                              const { naturalWidth, naturalHeight } =
                                target as HTMLImageElement
                              setImageHeight(naturalHeight)
                            }}
                            src={img?.url}
                            alt="Collection Banner"
                            fetchPriority={idx === 0 ? 'high' : 'low'}
                            style={{
                              height: `${
                                imageHeight !== 0
                                  ? imageHeight
                                  : DESKTOP_BANNER_IMAGE_HEIGHT
                              }px`,
                            }}
                          />
                        </a>
                      ) : (
                        <a
                          onClick={() => bannerClick(img, idx)}
                          className="block image-container"
                        >
                          <img
                            src={
                              generateUri(img?.url, 'h=795&q=50') ||
                              IMG_PLACEHOLDER
                            }
                            onLoad={({ target }) => {
                              setIsImageLoadedDesktop(true)
                              const { naturalWidth, naturalHeight } =
                                target as HTMLImageElement
                              setImageHeight(naturalHeight)
                            }}
                            alt="Collection Banner"
                            fetchPriority={idx === 0 ? 'high' : 'low'}
                            className={'image'}
                            style={{
                              height: '100% !important',
                            }}
                          />
                        </a>
                      )}
                    </Link>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </div>
    </>
  )
}
